import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { RTL } from 'src/app/@theme/const';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-main-details',
  templateUrl: './main-details.component.html',
  styleUrl: './main-details.component.scss'
})
export class MainDetailsComponent implements AfterViewInit, OnDestroy {
  @Input() profileImage: string;
  @Input() userRole: string;
  @Input() userName: string;
  @Input() userCompany: string;
  userBranch: string;
  currentLang: string;
  // base: string = environment.filesUrl;
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private sessionService: SessionWrapperService,
    private baseService: BaseService,
    private themeLayoutService: ThemeLayoutService
  ) {
    this.currentLang = this.baseService.getCurrentLanguage();
    this.themeLayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => {
        (dir === RTL) ? this.currentLang = 'ar' : this.currentLang = 'en';
        this.getUserBranch();
      }
    })
  }

  ngAfterViewInit(): void {
    this.getUserBranch();
  }
  getUserBranch(): void {
    this.sessionService.currentDefaultBranchSubject$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        // console.log('res', res);
        this.userBranch = this.currentLang === 'ar' ? res?.brancharaname : res?.branchlatname;

      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
